import React from "react";
import { Reveal } from "./Motion";
import { Recycle, HandCoins, Leaf } from "lucide-react";

const POINTS = [
  { icon: HandCoins, t: "We resell — you save", d: "If any of your junk is resellable, we knock it off your haul price. Your clutter becomes your discount." },
  { icon: Recycle, t: "Donation-first sorting", d: "Usable furniture, appliances, and goods get routed to local charities and our marketplace before the landfill." },
  { icon: Leaf, t: "Less waste, guaranteed", d: "We keep reusable items in circulation. Cleaner conscience, lighter dump fees, better price for you." },
];

export default function Donations() {
  return (
    <section id="donations" data-testid="donations-section" className="relative bg-[var(--accent)] text-white py-24 md:py-36 overflow-hidden">
      <div className="absolute inset-0 grid-lines opacity-20" />
      <div className="relative max-w-[1600px] mx-auto px-5 md:px-10">
        <Reveal className="max-w-4xl mb-16">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/70">/ Donations & Resale Discount</span>
          <h2 className="font-display text-5xl md:text-8xl font-black uppercase tracking-tighter mt-4 leading-[0.85]">Your junk might pay for itself.</h2>
          <p className="text-white/80 text-lg leading-relaxed mt-8 max-w-2xl">Here's the deal: if we haul your stuff and it's resellable, we discount your price for it. We'd rather rehome a good couch than dump it — and pass the savings straight to you.</p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-px bg-white/20 border border-white/20">
          {POINTS.map((p, i) => (
            <Reveal key={p.t} delay={i * 0.1} className="bg-[var(--accent)] p-8 md:p-10 hover:bg-[#e63e00] transition-colors duration-300">
              <p.icon size={32} className="mb-6" strokeWidth={1.5} />
              <h3 className="font-display text-2xl font-bold uppercase mb-3">{p.t}</h3>
              <p className="text-white/80 leading-relaxed">{p.d}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
